export default __webpack_public_path__ + "static/media/pt-session-add.3c0af349.svg";